class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="m2.62 11.255.715-.71A7.03 7.03 0 0 1 1.535 8C2.55 5.465 5.35 3.5 8 3.5a6.19 6.19 0 0 1 2 .36l.775-.78A7.36 7.36 0 0 0 8 2.5 8.345 8.345 0 0 0 .53 7.83a.5.5 0 0 0 0 .34 8 8 0 0 0 2.09 3.085Z"></path><path d="M6 7.865a2 2 0 0 1 1.85-1.85l.905-.91A3 3 0 0 0 5.09 8.77L6 7.865Zm9.47-.035a8.2 8.2 0 0 0-2.87-3.72L15 1.705 14.295 1 1 14.295l.705.705 2.55-2.55A7.645 7.645 0 0 0 8 13.5a8.346 8.346 0 0 0 7.47-5.33.5.5 0 0 0 0-.34ZM10 8a2 2 0 0 1-3 1.72L9.72 7A2 2 0 0 1 10 8Zm-2 4.5a6.524 6.524 0 0 1-3-.79l1.27-1.27a3 3 0 0 0 4.175-4.175L11.88 4.83A7.27 7.27 0 0 1 14.465 8C13.45 10.535 10.65 12.5 8 12.5Z"></path></svg>';
  }
}
const e = "pi-eye-off";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
